module.exports = __webpack_public_path__ + "img/icon_header_messages.789224eb.svg";